'use client'

import { Button, ButtonGroup } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { List, ListItem } from '@wartek-id/list'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'

import { ErrorDownloadDialog } from '@/components/ErrorDialog/ErrorDownloadDialog'

import { RedownloadDialog } from '../RedownloadDialog/RedownloadDialog'

type CommonDownloadFileButtonProps = {
  disabled?: boolean
  isPending?: boolean
  isShowErrorDialog?: boolean
  isShowConfirmationDialog?: boolean
  onCloseConfirmationDialog?: () => void
  onCloseErrorDialog?: () => void
  onConfirmed?: () => void
  onDownload?: (fileType: 'csv' | 'xlsx' | 'pdf') => void
  withRedownloadConfirmation?: boolean
  extensions: Array<'csv' | 'xlsx' | 'pdf'>
}

export const CommonDownloadFileButton = ({
  disabled = false,
  isPending = false,
  onDownload = (_fileType) => {},
  extensions = ['xlsx'],
  // Error Dialog
  isShowErrorDialog = false,
  onCloseErrorDialog = () => {},
  // Confirmation Dialog
  withRedownloadConfirmation = false,
  isShowConfirmationDialog = false,
  onCloseConfirmationDialog = () => {},
  onConfirmed = () => {},
}: CommonDownloadFileButtonProps) => {
  return (
    <>
      {extensions.length > 1 ? (
        <ButtonGroup color="blue">
          <Button
            onClick={() => {
              onDownload('xlsx')
            }}
            className="!rounded-l"
            data-testid="btn-download"
            disabled={disabled || isPending}
          >
            Unduh Data
          </Button>
          <Popover>
            <PopoverTrigger as="div">
              <Button
                iconOnly
                className="!rounded-r"
                data-testid="btn-expander"
                aria-label="Expand more"
                disabled={disabled || isPending}
              >
                <Icon color="inherit">expand_more</Icon>
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <List type="menu">
                {extensions.map((ext) => (
                  <ListItem
                    key={ext}
                    disabled={disabled || isPending}
                    onClick={() => {
                      onDownload(ext)
                    }}
                    className="w-[150px]"
                    data-testid={`item-${ext}`}
                  >
                    {ext.toUpperCase()}
                  </ListItem>
                ))}
              </List>
            </PopoverContent>
          </Popover>
        </ButtonGroup>
      ) : (
        <Button
          onClick={() => {
            onDownload('xlsx')
          }}
          size="lg"
          data-testid="btn-download"
          disabled={disabled || isPending}
        >
          Unduh Data
        </Button>
      )}

      {withRedownloadConfirmation && (
        <RedownloadDialog
          show={isShowConfirmationDialog}
          onClose={onCloseConfirmationDialog}
          onConfirm={onConfirmed}
        />
      )}

      <ErrorDownloadDialog
        show={isShowErrorDialog}
        onClose={onCloseErrorDialog}
      />
    </>
  )
}
